import { Button } from 'antd';
import styled from 'styled-components';

export const TaskWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VerticalMenuButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black8};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-self: flex-start;
`;
